import React, { useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import siteLogo from './site_logo.png'
import FeatherIcon from 'feather-icons-react'

function Layout({ children }) {
  const location = useLocation()
  const isBloggPage = location.pathname === '/blogg'

  useEffect(() => {
    // const gtmScript = document.createElement("script");
    // gtmScript.async = true;
    // gtmScript.src = "https://www.googletagmanager.com/gtm.js?id=GTM-T7ZL24QT";
    // document.head.appendChild(gtmScript);
    // // Load the Google Tag Manager script
    // const gtagScript = document.createElement("script");
    // gtagScript.async = true;
    // gtagScript.src =
    //   "https://www.googletagmanager.com/gtag/js?id=AW-11556258873";
    // document.head.appendChild(gtagScript);

    // // Initialize Google Analytics
    // gtagScript.onload = () => {
    //   window.dataLayer = window.dataLayer || [];
    //   function gtag() {
    //     window.dataLayer.push(arguments);
    //   }
    //   window.gtag = gtag;
    //   gtag("js", new Date());
    //   gtag("config", "AW-11556258873");
    //   gtag("config", "GTM-T7ZL24QT"); // Add GTM tracking
    // };

    // Add JSON-LD schema
    const jsonLdScript = document.createElement('script')
    jsonLdScript.type = 'application/ld+json'
    jsonLdScript.text = JSON.stringify({
      '@context': 'https://schema.org',
      '@type': 'WebSite',
      name: 'Kronos',
      url: 'https://kronos.se/',
      description:
        'Köp och sälj klockor tryggt via Kronos. Sveriges nya marknadsplats för att sälja och köpa klockor',
      mainEntityOfPage: {
        '@type': 'WebPage',
        '@id': 'https://kronos.se/',
      },
      publisher: {
        '@type': 'Organization',
        name: 'Kronos',
        url: 'https://kronos.se/',
        logo: {
          '@type': 'ImageObject',
          url: 'https://kronos.se/static/media/site_logo.4014536f41ed5684e1ee.png',
          width: 300,
          height: 100,
        },
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'info@kronos.se',
          contactType: 'customer service',
          areaServed: 'SE',
          availableLanguage: 'Swedish',
        },
      },
    })

    document.head.appendChild(jsonLdScript)
  }, [])

  return (
    <>
      <header className="absolute inset-x-0 top-0 z-50 bg-white">
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap"
          rel="stylesheet"
        />
      </header>
      <main className={isBloggPage ? '' : 'mt-24'}>{children}</main>
      <footer className="bg-gray-50 py-4 text-center text-gray-600 font-poppins">
        <p className="my-2">
          Kontakt:{' '}
          <a href="mailto:info@kronos.se" className="underline">
            info@kronos.se
          </a>
        </p>
        <div className="flex flex-col justify-center items-center my-6">
          <p className="font-poppins text-lg mb-4 text-gray-800">Följ oss på</p>
          <div className="flex flex-row justify-center items-center gap-6">
            <a
              href="https://www.facebook.com/profile.php?id=61573060364645"
              className="flex items-center justify-center bg-blue-600 rounded-full p-3 transition-transform duration-200 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FeatherIcon icon="facebook" size={25} color="white" />
            </a>

            <a
              href="https://www.instagram.com/kronosappen/"
              className="flex items-center justify-center bg-gradient-to-tr from-yellow-400 via-pink-500 to-purple-600 rounded-full p-3 transition-transform duration-200 hover:scale-110"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FeatherIcon icon="instagram" size={25} color="white" />
            </a>
          </div>
        </div>
        © 2025 Kronos - Utvecklat av App Labs Sweden AB
      </footer>
    </>
  )
}

export default Layout
